<div class="error-container">
  <div class="error-card">
    <div class="error-icon">
      <fa-icon [icon]="['fas', Icon.ExclamationTriangle]" size="4x"></fa-icon>
    </div>
    <span class="error-title">{{ 'global.error.title' | translate }} {{ code() > 0 ? code() : 'unknown' }}</span>
    <div class="error-message">
      <div class="user-greeting">Hi, {{ user()?.firstName }} {{ user()?.lastName }}</div>
      <div class="error-detail">
        @switch (errorReason) {
        @case ('authentication_failed') {
        {{ 'global.error.authentication_failed' | translate }}
        }
        @case ('pharmacy_associate_user_error') {
        {{ 'global.error.pharmacy_associate_user_error' | translate }}
        }
          @case ('unauthorized') {
            {{ 'global.error.unauthorized' | translate }}
          }
        @default {
        {{ 'global.error.unknown' | translate }}
        }
        }
      </div>
    </div>
    <div class="error-actions">
      @if (code() == 999) {
      <button class="btn btn-primary" (click)="retryLogin()">
        <fa-icon [icon]="['fas', Icon.Retry]" class="mr-2"></fa-icon>
        <span>{{ 'global.error.retry_login' | translate }}</span>
      </button>
      } @else if (errorReason === 'unauthorized') {
      <button class="btn btn-primary" (click)="logout()">
        <fa-icon [icon]="['fas', Icon.Logout]" class="mr-2"></fa-icon>
        <span>{{ 'global.error.logout' | translate }}</span>
      </button>
      } @else {
      <button class="btn btn-secondary" (click)="goBack()">
        <fa-icon [icon]="['fas', Icon.Logout]" class="mr-2"></fa-icon>
        <span>{{ 'global.error.go_back' | translate }}</span>
      </button>

      <button class="btn btn-secondary" (click)="goHome()">
        <fa-icon [icon]="['fas', Icon.Home]" class="mr-2"></fa-icon>
        <span>{{ 'global.error.go_home' | translate }}</span>
      </button>
      }
    </div>
  </div>
</div>